<template>
  <eg-modal
    id="upgrade-plan-modal"
    :title="$t('account.subscription.upgradeTitle')"
    size="content"
    centered
  >
    <template #header>
      <div class="modal-header">
        <div class="left-content">
          <div class="heading-s semi-bold">
            {{ $t("account.subscription.upgradeTitle") }}
          </div>

          <div v-if="showSubscriptionActions" class="modal-header-toggle">
            <div class="paragraph-s color-text-neutral-fade">
              {{ $t("account.subscription.monthly") }}
            </div>

            <toggle-button
              v-model="yearlyToggle"
              :labels="false"
              color="#8A3FFC"
              :width="40"
              :height="22"
              :disabled="isPaused || isCurrentPlanYearly"
            />

            <div class="d-flex align-items-center gap-2">
              <div class="paragraph-s medium">
                {{ $t("account.subscription.annually") }}
              </div>
              <!--<div class="discount-badge caption-xs">
                {{ discountPercent }}% OFF
              </div>-->
            </div>
          </div>
        </div>

        <eg-button
          type="ordinary"
          size="medium"
          class="eg-modal__close"
          icon="close"
          icon-size="medium"
          icon-color="var(--color-icon-neutral-neutral)"
          @click="closeModal"
        />
      </div>
    </template>

    <div class="upgrade-plan-modal-content">
      <pricing-cards
        v-if="showSubscriptionActions"
        :yearly-toggle="yearlyToggle"
        :current-plan="currentPlan"
        @select-plan="selectPlan"
      />

      <div v-else>
        <div class="">
          {{ $t("account.subscription.contactAdminToUpgrade") }}
        </div>
      </div>
    </div>
  </eg-modal>
</template>

<script>
import PricingCards from "@/components/account/pricing-cards.vue";
import { ToggleButton } from "vue-js-toggle-button";

export default {
  name: "UpgradePlanModal",

  components: {
    PricingCards,
    ToggleButton,
  },

  inject: ["accountProvider"],

  props: {
    discountPercent: {
      type: Number,
      default: 30,
    },
    currentPlan: {
      type: Object,
      default: () => ({}),
    },
  },

  data() {
    return {
      yearlyToggle: true,
    };
  },

  computed: {
    paymentInterval() {
      return this.accountProvider.paymentInterval;
    },

    showSubscriptionActions() {
      return this.accountProvider.showSubscriptionActions;
    },

    isPaused() {
      return this.$store.getters.isPaused;
    },

    isCurrentPlanYearly() {
      return this.paymentInterval === "year";
    },
  },

  watch: {
    paymentInterval: {
      handler(newVal) {
        // If paused, force monthly toggle (false)
        if (this.isPaused) {
          this.yearlyToggle = false;
        } else if (newVal === "year") {
          // User has yearly subscription - show yearly plans by default
          this.yearlyToggle = true;
        } else if (
          newVal === "month" &&
          this.accountProvider.isUserSubscribed
        ) {
          // User has monthly subscription - show monthly plans by default
          this.yearlyToggle = false;
        } else {
          // User has no subscription or data not loaded yet - default to yearly plans
          this.yearlyToggle = true;
        }
      },
      immediate: true,
    },

    isPaused: {
      handler(newVal) {
        // If subscription gets paused, force monthly toggle
        if (newVal) {
          this.yearlyToggle = false;
        }
      },
      immediate: true,
    },
  },

  methods: {
    closeModal() {
      this.$egModal.hide("upgrade-plan-modal");
    },

    selectPlan() {
      this.closeModal();
    },
  },
};
</script>

<style scoped lang="scss">
.upgrade-plan-modal-content {
  padding: 47px 0;
  display: flex;
  justify-content: center;
  align-items: center;
}

.modal-header {
  display: flex;
  align-items: center;
  justify-content: space-between;

  .left-content {
    padding: 16px 24px;
    display: flex;
    align-items: center;
    justify-content: start;
    gap: 24px;
  }

  .modal-header-toggle {
    display: flex;
    align-items: center;
    gap: 8px;
  }

  label.vue-js-switch {
    margin: 0 !important;
  }
}
</style>
